




























import { Component, Inject, Watch, Mixins } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import VueScrollTo from 'vue-scrollto';
import IsPfdodCheckMixin from '@/mixins/isPfdodCheck';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import Infotext from '@/components/parts/infotext';
import { Accordion } from '@/pages/profile/components';
import store, { InitialState } from '@/pages/profile/store';
import {
  Header,
  Footer,
  Toggle,
  ChildrenList,
  NewChildButton,
  AddChildForm,
  InvitedPerson,
} from './components';
import { ISidebar } from './types';
import getAgeFromBirthday from '@/tools/getAgeFromBirthday';
import { CreateInvite, inviteService } from '@/services';
import { DataParsedPerson } from '@/services';

@Component({
  components: {
    Header,
    Footer,
    Toggle,
    Accordion,
    ChildrenList,
    NewChildButton,
    AddChildForm,
    LoadingSpinner,
    Infotext,
    InvitedPerson,
  },
})
export default class Sidebar
  extends Mixins(IsPfdodCheckMixin)
  implements ISidebar
{
  @Inject() $api: AxiosInstance;

  sidebarShow = true;
  isLoading = false;
  formOpen = false;
  invitedPersons: DataParsedPerson = [];
  errors = {
    first_name: '',
  };
  errorText = '';

  get modules() {
    const modules: Array<string> = [];
    modules.push('noko');
    return modules;
  }

  get user() {
    const { profile } = this.$store.state.user;
    if (!profile) return null;

    store.id = profile.id;

    return {
      id: profile.id,
      first_name: profile.first_name,
      last_name: profile.last_name,
      age: profile.birthday ? getAgeFromBirthday(profile.birthday) : '',
      sex: profile.sex,
      active: true,
    };
  }

  get state(): InitialState {
    return store.state;
  }

  get routeQueryFormOpen(): boolean {
    return !!this.$route.query.formOpen;
  }

  get id(): string {
    return this.state.id;
  }

  get selector(): number {
    return this.state.selector;
  }

  get onConfirm(): boolean {
    return store.confirmed;
  }

  get storeMethod(): string {
    return store.method;
  }

  @Watch('apiErrors')
  setErrors(value: any) {
    if (value) {
      this.errors = value;
    }
  }

  // created() {
  //   this.getInvitedPersons();
  // }

  beforeDestroy() {
    store.reset();
  }

  toggleSidebar(): void {
    this.sidebarShow = !this.sidebarShow;
    if (!this.sidebarShow) {
      this.scrollToTop();
    }
  }

  clearRouteQuery(): void {
    if (this.routeQueryFormOpen) {
      this.$router.push({ query: {} });
    }
  }

  toggleForm(): void {
    this.formOpen = !this.formOpen;
    this.clearRouteQuery();
    if (this.formOpen) {
      this.scrollToTop();
    }
  }

  scrollToTop() {
    VueScrollTo.scrollTo('body', 500, {
      easing: 'ease-in-out',
    });
  }

  setError(text: string) {
    store.isNoButtons = true;
    store.modalText = text;
  }

  // async submit(value: CreateInvite) {
  //   const { $api } = this;
  //   this.isLoading = true;
  //
  //   try {
  //     await inviteService($api).postCreateInvite(value);
  //     this.getInvitedPersons();
  //     this.formOpen = false;
  //   } catch (error) {
  //     const { errors } = error.response.data;
  //     this.isLoading = false;
  //     if (errors) {
  //       this.errors = errors.reduce((sum: any, { attribute, msg }: any) => {
  //         sum[attribute] = msg;
  //         return sum;
  //       }, {});
  //     }
  //   }
  // }

  // async getInvitedPersons() {
  //   const { $api } = this;
  //
  //   try {
  //     const { data } = await inviteService($api).getCurrentInvite();
  //     this.invitedPersons = [...data].reverse();
  //   } catch (error) {
  //   } finally {
  //     this.isLoading = false;
  //   }
  // }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/Sidebar.vue